import { useRef, useState } from "react";
import api from "../lib/api";
import { Input } from "./ui/input";
import { MapPin } from "lucide-react";

export const GoogleAddressInput = ({ value, onChange, onPick, testid, placeholder }) => {
  const [res, setRes] = useState([]);
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  const search = (val) => {
    onChange(val);
    if (timer.current) clearTimeout(timer.current);
    if (val.trim().length < 3) { setRes([]); setShow(false); return; }
    timer.current = setTimeout(async () => {
      try { const { data } = await api.get("/maps/autocomplete", { params: { q: val } }); setRes(data); setShow(data.length > 0); }
      catch { setRes([]); setShow(false); }
    }, 350);
  };
  const pick = async (s) => {
    setShow(false); setRes([]);
    try {
      const { data: d } = await api.get("/maps/place", { params: { place_id: s.placeId, text: s.text } });
      onPick({ indirizzo: d.indirizzo || s.text, lat: d.lat ?? null, lng: d.lng ?? null });
    } catch { onPick({ indirizzo: s.text, lat: null, lng: null }); }
  };
  return (
    <div className="relative">
      <Input data-testid={testid} value={value} autoComplete="off" placeholder={placeholder || "Digita per l'autocompletamento Google Maps..."}
        onChange={(e) => search(e.target.value)} onFocus={() => { if (res.length) setShow(true); }}
        onBlur={() => setTimeout(() => setShow(false), 150)} className="mt-1.5" />
      {show && res.length > 0 && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-auto">
          {res.map((s) => (
            <button type="button" key={s.placeId} data-testid={`${testid}-opt`} onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b border-slate-100 last:border-0 flex items-center gap-2">
              <MapPin className="h-3.5 w-3.5 text-primary shrink-0" /> {s.text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
